import React, { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';

import { SonntagIcon } from "../SonntagIcon";

import { NoteType, PaymentMethod, isNextPaymentNote } from "./types";
import * as NoteIcons from "./noteIconPaths";

import { Container, Text, IconWrap, AnimatedInProgressIcon } from "./styles";







export const Note = ({ className, type, data }) => {
  const theme = useContext(ThemeContext);

  const text = isNextPaymentNote(data) ? data.date : data.text;

  const textColor = useMemo(() => {
    const textColorKeymap = {
      [NoteType.Attention]: '#F35757',
      [NoteType.Ended]: theme.colors['Level 4'],
      [NoteType.Paused]: theme.colors['Level 4'],
      [NoteType.NextPayment]: theme.colors['Level 5'],
      [NoteType.Processing]: theme.colors['Level 5'],
      [NoteType.Text]: theme.colors['Level 4'] };


    return type ? textColorKeymap[type] : theme.colors['Level 5'];
  }, [type, theme]);

  const icon = useMemo(() => {
    switch (type) {
      case NoteType.Attention:{
          return /*#__PURE__*/React.createElement(SonntagIcon, { iconPath: NoteIcons.ATTENTION, color: "#F35757" });
        }
      case NoteType.Ended:{
          return /*#__PURE__*/React.createElement(SonntagIcon, { iconPath: NoteIcons.ENDED, color: theme.colors['Level 4'] });
        }
      case NoteType.Paused:{
          return /*#__PURE__*/React.createElement(SonntagIcon, { iconPath: NoteIcons.PAUSED, color: theme.colors['Level 4'] });
        }
      case NoteType.NextPayment:{
          let iconPath = '';

          if (isNextPaymentNote(data)) {
            iconPath =
            data.paymentMethod.type === PaymentMethod.Paypal ?
            NoteIcons.PAYPAL :
            NoteIcons.CARD;
          }

          return /*#__PURE__*/React.createElement(SonntagIcon, { iconPath: iconPath, color: theme.colors.secondary });
        }
      case NoteType.Processing:{
          return /*#__PURE__*/React.createElement(AnimatedInProgressIcon, { color: theme.colors.secondary });
        }
      case NoteType.Text:
        return null;
      default:
        return null;}

  }, [data, theme, type]);

  return /*#__PURE__*/(
    React.createElement(Container, { className: className },
    !!icon && /*#__PURE__*/React.createElement(IconWrap, null, icon), /*#__PURE__*/
    React.createElement(Text, { color: textColor }, text)));


};